<template>
    <v-container class="video-container align-center justify-center text-center">

        <v-container class="ml-0 loader-container" fluid v-if="loading">
            <v-progress-circular color="#006D94" indeterminate></v-progress-circular>
        </v-container>

        <v-responsive class="custom-single-training-media align-center justify-center" v-if="!loading">
            <div ref="displayContainer" class="guacamole-display align-center justify-center"
                style="width: 100%; height: calc(100vh - 200px); border: 1px solid black;">
            </div>
        </v-responsive>
    </v-container>
</template>


<style scoped>
.loader-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
}

.video-container {
    position: fixed;
    width: 100vw;
    height: 100vh;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
}

.v-system-bar {
    width: 100%;
}

.custom-single-training-media {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.responsive-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.custom-single-training-media {
    box-shadow: 0px 3px 17px -3px rgba(0, 0, 0, 0);
    -webkit-box-shadow: 0px 3px 17px -3px rgba(0, 0, 0, 0.);
    -moz-box-shadow: 0px 3px 17px -3px rgba(0, 0, 0, 0);
}
</style>

<script>
import axios from 'axios';
import config from '../config.js';
import { ref } from 'vue';
//import { Client, WebSocketTunnel, Keyboard, Mouse } from 'guacamole-common-js';

const displayRef = ref(null);

export default {
    data() {
        return {
            loading: true,
            drawer: false,
            videoSrc: '../assets/digital-triplet-example.mp4',
            client: null,
            tunnel: null,
            keyboard: null,
            mouse: null,
            authToken: null,
            guac: undefined,
        };
    },
    mounted() {
        document.title = 'TIS Digital Triplet'
        setTimeout(async () => {
            this.loading = false;
            this.connectToGuacamole();
        }, 500);
        window.addEventListener('resize', this.updateConnectionDimensions);
    },
    unmounted() {
        console.debug("beforeDestroy")
        this.disconnectGuacamole();
        this.mouse.onmousedown = null;
        this.mouse.onmouseup = null;
        this.mouse.onmousemove = null;
        this.client.onstatechange = null;
        this.keyboard.onkeydown = null;
        this.keyboard.onkeyup = null;
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateConnectionDimensions);
    },
    methods: {
        updateConnectionDimensions(e) {
            //console.debug(e)
            const container = this.$el.getElementsByClassName('guacamole-display')[0];

            // Ermitteln der Breite und Höhe des Containers
            const width = container.offsetWidth;
            const height = container.offsetHeight;

            /*console.debug(width)
            console.debug(height)
            this.tunnel.sendMessage('size', width, height)
            this.$refs.displayContainer.appendChild(this.client.getDisplay().getElement());*/
        },
        close() {
            this.$router.push('/');
        },
        async connectToGuacamole() {
            try {
                await this.fetchAuthToken();
                const guacModule = await import('guacamole-common-js');
                this.guac = guacModule;
                let Client = guacModule.default.Client || guacModule.Client;
                let WebSocketTunnel = guacModule.default?.WebSocketTunnel || guacModule.WebSocketTunnel;
                this.tunnel = new WebSocketTunnel(`${config.websocketURL}/guacamole/websocket-tunnel`);

                this.tunnel.onerror = (error) => {
                    console.error("Tunnel Error:", error);
                };
                this.client = new Client(this.tunnel);

                //this.tunnel = guacModule.WebSocketTunnel;
                // Hole das Authentifizierungs-Token

                const container = this.$el.getElementsByClassName('guacamole-display')[0];

                // Ermitteln der Breite und Höhe des Containers
                const width = container.offsetWidth;
                const height = container.offsetHeight;

                console.debug(width)
                console.debug(height)

                // Aufbau der Verbindung mit dynamischen Werten
                //this.client.connect(`token=${this.authToken}&GUAC_DATA_SOURCE=default&GUAC_ID=Windows-Desktop&GUAC_TYPE=c&GUAC_WIDTH=${width}&GUAC_HEIGHT=${height}&GUAC_DPI=96`);

                // Verbindung zum Guacamole-Server herstellen
                this.client.connect(`token=${this.authToken}&GUAC_DATA_SOURCE=default&GUAC_ID=Windows-Desktop&GUAC_TYPE=c&GUAC_WIDTH=${width}&GUAC_HEIGHT=${height}&GUAC_DPI=96`);

                console.debug(this.client)
                this.$refs.displayContainer.appendChild(this.client.getDisplay().getElement());

                // Tastatur- und Mausereignisse einrichten
                let Keyboard = guacModule.default.Keyboard || guacModule.Keyboard;
                this.keyboard = new Keyboard(document);

                let Mouse = guacModule.default.Mouse || guacModule.Mouse;
                this.mouse = new Mouse(this.client.getDisplay().getElement());

                // Mausereignisse an den Client senden
                this.mouse.onmousedown = (x, y, button) => this.client.sendMouseState(this.mouse.currentState);
                this.mouse.onmouseup = (x, y, button) => this.client.sendMouseState(this.mouse.currentState);
                this.mouse.onmousemove = (x, y) => this.client.sendMouseState(this.mouse.currentState);
                //this.keyboard = new Keyboard(document);
                //this.mouse = new Mouse(this.client.getDisplay().getElement());

                this.client.onstatechange = (state) => {
                    console.log("Client state changed:", state);
                };

                document.addEventListener('keydown', (event) => {
                    console.log(`Taste gedrückt: ${event.key}`);
                });

                this.keyboard.onkeydown = (keysym) => this.client.sendKeyEvent(1, keysym);
                this.keyboard.onkeyup = (keysym) => this.client.sendKeyEvent(0, keysym);

            } catch (error) {
                console.error('Fehler bei der Verbindung zu Guacamole:', error);
            }
        },

        async fetchAuthToken() {
            try {
                const response = await fetch(`${config.baseURL.replace(':8000', '')}/guacamole/api/tokens`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({
                        username: 'simulation-user',
                        password: 'uCuOe2xnBzq5hiKz',
                    }),
                });
                const data = await response.json();
                this.authToken = data.authToken;
            } catch (error) {
                console.error('Fehler beim Abrufen des Authentifizierungstokens:', error);
                throw error;
            }
        },

        disconnectGuacamole() {
            if (this.client) {
                this.client.disconnect();
            }
        }
    },
};
</script>
